export const registrationClientContext = {
  firstStage: '/user-service/api/external/companies/registartion/firstStage',
  secondStage: '/user-service/api/external/companies/registartion/secondStage',
  thirdStage: '/user-service/api/external/companies/registartion/thirdStage',
  reset: '/user-service/api/external/companies/registartion/reset',
};
